/*
 * @Author: zhoupeng 
 * @Date: 2018-09-15 13:57:15 
 * @Last Modified by: Michael
 * @Last Modified time: 2019-09-17 10:51:42
 */

<template>
  <div class="xm-audio-new">
    <div v-if='audioType === "voice_file"' class="audio-file">
      <audio :src="voiceSrc" ref="audio"></audio>
      <img :src="audioFile" class="audio-file-img" />
      <div class="audio-file-progress">
        <div class="audio-file-text">
          <div class="audio-file-name">{{audioName}}</div>
          <!-- <div>.mp3</div> -->
        </div>
        <div class="audio-progress" @click="handleChangeAudioFile" id="audio-file-progres">
          <div :style="{width: ( (voiceNum/realTime)*1.9>1.9?1.9:(voiceNum/realTime)*1.9)+'rem'}" class="voice-now-progress"></div>
          <div class="voice-icon" :style="{left: -0.12+( (voiceNum/realTime)*1.9>1.9?1.9:(voiceNum/realTime)*1.9)+'rem'}" @touchstart="move" id="voice-icon"></div>
          <span class="voice-time" v-if="time">{{showNow}}/{{showTime}}</span>
        </div>
      </div>
      <img class="voice-img" id="voice" :src="playStyle ? audioFilePlay : audioFileStop" @click.stop="handlePlayAudio"/>
    </div>
    <div v-else class="audio-sound">
      <audio :src="voiceSrc" ref="audio" id="audio"></audio>
      <img class="voice-img" ref="audioImg" id="voice" :src="playStyle ? audioPlay : audioStop" @click.stop="handlePlayAudio"/>
      <div class="audio-progress" @click="handleChangeAudio" id="audio-progres">
        <div :style="{width: ( (voiceNum/realTime)*2.92>2.92?2.92:(voiceNum/realTime)*2.92)+'rem'}" class="voice-now-progress"></div>
        <div class="voice-icon" :style="{left: -0.12+( (voiceNum/realTime)*2.92>2.92?2.92:(voiceNum/realTime)*2.92)+'rem'}" @touchstart="move" id="voice-icon"></div>
      </div>
      <span class="voice-time" v-if="time">{{showNow}}/{{showTime}}</span>
    </div>
  </div>
</template>

<script>
import audioPlay from "@/images/audioPlay.png";
import audioStop from "@/images/audioStop.png";
import VideoUpload from "@/service/UploaderService";
import audioFile from "@/images/audio_file.png"
import audioFileStop from "@/images/audio_file_stop.png"
import audioFilePlay from "@/images/audio_file_play.png"

export default {
  name: "xm-audio-new",
  props: {
    audioSrc: {
      type: String,
      required: true
    },
    size: {
      type: [Number,String],
      required: true
    },
    handleClick: {
      type: Boolean,
      required: false,
      default: true
    },
    audioType:{
      type: String,
      required: false
    },
    audioName:{
      type:String,
      required:false
    }
  },
  components: {
    //Example
  },

  data() {
    return {
      audioPlay,
      audioStop,
      audioFile,
      audioFileStop,
      audioFilePlay,
      playStyle:false,
      voiceTime: 0,
      audio: null,
      time: 0,
      voiceSrc: "",
      progressLeft: 0.96,
      voiceNum: 0,
      realTime:0,
      showTime:'',
      showNow:'00:00'
    };
  },

  methods: {
    handlePlayAudio(event) {
      const audioList = document.getElementsByTagName("audio");
      _.each(audioList, temp => {
        if (temp != this.audio) {
          temp.pause();
        }
      });
      
      const imgstyle = document.getElementsByClassName("xm-audio-new")
      _.each(imgstyle,res =>{
        res.__vue__.$data.playStyle = false;
      })
      this.playStyle = true
      if (this.audio.paused) {
        this.audio.play();
        this.playStyle = true;
        this.voiceTime = setInterval(this.changeVoiceNum, 100);
      } else {
        this.clearInterval();
        this.playStyle = false;
        this.audio.pause();
      }

      this.audio.onended = () => {
        this.clearInterval();
        this.playStyle = false;
        this.audio.pause();
      };
    },

    handleChangeAudio(event){
      let audioProgress = document.getElementById("audio-progres");
      if(event.target.id == "voice-icon"){
        return false
      }
      if(this.audio.paused){
        const audioList = document.getElementsByTagName("audio");
        _.each(audioList, temp => {
          if (temp != this.audio) {
            temp.pause();
          }
        });
        this.handlePlayAudio()
      }
      let rate = event.offsetX / audioProgress.offsetWidth;
      this.audio.currentTime = this.audio.duration * rate;
      this.changeVoiceNum()
    },

    handleChangeAudioFile(event){
      let audioProgress = document.getElementById("audio-file-progres");
      if(event.target.id == "voice-icon"){
        return false
      }
      if(this.audio.paused){
        const audioList = document.getElementsByTagName("audio");
        _.each(audioList, temp => {
          if (temp != this.audio) {
            temp.pause();
          }
        });
        this.handlePlayAudio()
      }
      let rate = event.offsetX / audioProgress.offsetWidth;
      this.audio.currentTime = this.audio.duration * rate;
      this.changeVoiceNum()
    },

    move(event){
      let dot = event.target
      const position = {
        oriOffestLeft: 0, // 移动开始时进度条的点距离进度条的偏移值
        oriX: 0, // 移动开始时的x坐标
        maxLeft: 0, // 向左最大可拖动距离
        maxRight: 0 // 向右最大可拖动距离
      };
      let flag = false; // 标记是否拖动开始
      const audio = this.audio;
      const that = this;
      
      // 开始拖动
      document.addEventListener('mousemove', move, false);
      document.addEventListener('touchmove', move, false);
      // 拖动结束
      document.addEventListener('mouseup', end, false);
      document.addEventListener('touchend', end, false);


      // if (!audio.paused) { // 只有音乐开始播放后才可以调节
          flag = true;
          position.oriOffestLeft = dot.offsetLeft;
          position.oriX = event.touches ? event.touches[0].clientX : event.clientX; // 要同时适配mousedown和touchstart事件
          position.maxLeft = position.oriOffestLeft; // 向左最大可拖动距离
          // 向右最大可拖动距离
          position.maxRight = dot.offsetParent.offsetWidth - position.oriOffestLeft; 
          // 禁止事件冒泡
          if (event && event.stopPropagation) {
              event.stopPropagation();
          } else {
              window.event.cancelBubble = true;
          }
      // }

      function move(event) {
        if (flag) {
            const clientX = event.touches ? event.touches[0].clientX : event.clientX; // 要同时适配mousemove和touchmove事件
            let length = clientX - position.oriX;
            if (length > position.maxRight) {
                length = position.maxRight;
            } else if (length < -position.maxLeft) {
                length = -position.maxLeft;
            }
            const progressBarBg = event.target.offsetParent;
            const rate = (position.oriOffestLeft + length) / progressBarBg.offsetWidth;
            audio.currentTime = audio.duration * rate;
            that.changeVoiceNum();
        }
      }

      function end() {
          flag = false;
      }
    },

    changeVoiceNum() {
      this.voiceNum = this.audio.currentTime;
      this.changeShowNow();
    },

    changeShowNow(){
      const voiceTime = Math.floor(this.voiceNum);
      const second = Math.floor(voiceTime % 60);
      const minute = Math.floor(voiceTime / 60);
      const showsecond = second <10 ? `0${second}` : second
      const showminute = minute <10 ? `0${minute}` : minute
      this.showNow = `${showminute}:${showsecond}`
    },

    clearInterval() {
      clearInterval(this.voiceTime);
    },

    dealVoiceParse() {
      VideoUpload.getVideoParseRoute(this.audioSrc).then(newUrl => {
        this.voiceSrc = newUrl;
      });
    },

    scrollEvent() {
      const el = this.$el;
      const rect = el.getBoundingClientRect();
      if (
        rect.top !== 0 &&
        rect.top < document.documentElement.clientHeight &&
        !this.voiceSrc
      ) {
        this.dealVoiceParse();
      }
    }
  },

  mounted() {
    this.audio = this.$refs.audio;
    let time = Math.floor(this.size / 1000);
    const s = this.size / 1000;
    const second = Math.floor(s % 60);
    const minute = Math.floor(s / 60);
    const showsecond = second <10 ? `0${second}` : second
    const showminute = minute <10 ? `0${minute}` : minute
    const showTime = `${showminute}:${showsecond}`;
    this.time = time;
    this.realTime = time;
    this.showTime = showTime
    this.scrollEvent();
    if (document.querySelector(".comment-detail-scroll-page")) {
      document
        .querySelector(".comment-detail-scroll-page")
        .addEventListener(
          "scroll",
          window.throttle(this.scrollEvent.bind(this))
        );
    // } else if (document.querySelector(".growth-index")) {
    //   document
    //     .querySelector(".growth-index")
    //     .addEventListener(
    //       "scroll",
    //       window.throttle(this.scrollEvent.bind(this))
    //     );
    } else {
      this.dealVoiceParse();
    }
  }
};
</script>

<style lang='less'>
.xm-audio-new {
  position: relative;
  display: flex;
  .audio-sound{
    height: 0.8rem;
    line-height: 0.8rem;
    background: #cceaff;
    border-radius: 0.1rem;
    width: 5.7rem;
    position: relative;
    display: flex;
    .audio-progress{
      position: relative;
      background: #ADD9FE;
      border-radius: 0.02rem;
      opacity: 0.8;
      width: 2.92rem;
      height: 0.04rem;
      margin: auto 0;
      margin-left: 0.2rem;
    }
    .voice-now-progress{
      position: absolute;
      height: 0.04rem;
      background: #3296FA;
    }
    .voice-icon{
      position: absolute;
      top: -0.10rem;
      width: 0.24rem;
      height: 0.24rem;
      background: #3296FA;
      border-radius: 100%;
    }
    .voice-img {
      top: 0;
      bottom: 0;
      margin: auto 0;
      margin-left: 0.24rem;
      display: block;
      width: 0.52rem;
      height: 0.52rem;
    }
    .voice-time {
      margin-left: 0.16rem;
      font-size: 0.26rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #687885;
    }
  }
  .audio-file{
    width: 5.7rem;
    height: 1.2rem;
    background: #F6F7F8;
    border-radius: 0.1rem;
    display: flex;
    position: relative;
    .audio-file-img{
      width: 0.8rem;
      height: 0.8rem;
      margin: auto 0;
      margin-left: 0.2rem;
    }
    .audio-file-progress{
      margin-left: 0.16rem;
      display: flex;
      flex-flow: column;
      .audio-file-text{
        margin-top: 0.2rem;
        width: 3.36rem;
        height: 0.36rem;
        font-size: 0.26rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 0.36rem;
        display: flex;
        .audio-file-name{
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
      }
      .audio-progress{
        position: relative;
        opacity: 0.8;
        margin-top: 0.26rem;
        width: 1.9rem;
        height: 0.04rem;
        background: #E8E8E8;
        border-radius: 0.02rem;
      }
      .voice-now-progress{
        position: absolute;
        height: 0.04rem;
        background: #3296FA;
      }
      .voice-icon{
        position: absolute;
        top: -0.10rem;
        width: 0.24rem;
        height: 0.24rem;
        background: #3296FA;
        border-radius: 100%;
      }
      .voice-time{
        font-size: 0.22rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 0.28rem;
        position: absolute;
        right: -1.54rem;
        top: -0.11rem;
        pointer-events: none;
      }
    } 
    .voice-img{
      margin: auto 0;
      margin-left: 0.4rem;
      display: block;
      width: 0.52rem;
      height: 0.52rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/AudioNew.vue